module.exports = __webpack_public_path__ + "static/media/bigdot1.6b5b5df2.png";